/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Max {
  /**
   * Identify the maximum number of a pair of numbers
   *
   * @public
   * @function f1.max
   * @param a the first number
   * @param b the second number
   * @example
   *
   * ```ts
   * f1.max(3, 6) => 6
   *
   * f1.reduce(f1.max, [3, 6, 9]) => 9
   * f1.reduce(Math.max, [3, 6, 9]) => NaN
   * ```
   */
  (a: number, b: number): number;
  /**
   * {@link FnMaxValue}
   * @param a the first number
   */
  (a: number): (b: number) => number;
}

/**
 * @see Max
 */
export default (a: number, b: number) => (a > b ? a : b);
